{
  "display_name": "Andre",
  "doc_count": "2",
  "documents_url": "https://dev.hearthfire.ai/documents",
  "household_name": "Andre's household",
  "summary": "• Andre — US passport expires 2026-08-12 (94 days)\n• Christianna — driver's license expires 2026-07-30 (81 days)"
}
